<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
    <div class="mx-auto flex w-full flex-wrap p-4">
        <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
            <div>
                <div class="flex items-center gap-1">
                    <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
                        <button mat-icon-button color="primary">
                        <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
                        </button>
                    </div>
                    <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
                        <div class="p-4">
                        <p>
                            Personas con acceso a este espacio o
                            integración. Agrega o quita miembros y
                            define su rol. Úsalo para dar permisos
                            correctos sin exponer información sensible.
                        </p>
                        </div>
                    </mat-menu>
                    <h2 class="text-xl font-semibold leading-8 tracking-tight">
                        Miembros
                    </h2>
                </div>
                <div class="text-sm text-secondary font-medium tracking-tight">
                    Activa/inactiva, crea, actualiza y elimina los <b>miembros</b> para el envío de <b>notificaciones</b> dentro de AVE.
                </div>
            </div>
        <!-- Header -->
        <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
            <div class="flex shrink-0">
            <!-- Title -->
            <!--<div class="text-3xl font-extrabold tracking-tight">Tipos de Vehiculo</div> -->
                <app-status-filters [selectedStatuses]="selectedStatuses"
                    [showStatus]="[1,0]" [typeFilter]="'master'"  (selectionFilterApply)="getList()">
                </app-status-filters>
        </div>
          <!-- Actions -->
          <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
              <button mat-icon-button color="primary" (click)="openModal()" matTooltip="Nuevo Registro">
                  <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
              </button>
          </div>
      </div>
    </div>
      <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
        <!-- Main Content (Table and Paginator) -->
        <div class="pt-1 mx-6">
          <!-- Tabla -->
          <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
            <!-- Header -->
            <div class="overflow-auto flex-1 dark:bg-gray-900">
              <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" matSort
                  (matSortChange)="changeSort($event)" matSortDisableClear multiTemplateDataRows>

                  <ng-container matColumnDef="name">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre</th>
                      <td mat-cell *matCellDef="let element" class="text-sm uppercase">
                          {{ element?.name}}
                      </td>
                  </ng-container>
                  
                  <!-- Company -->
                  <ng-container matColumnDef="company">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Compañía</th>
                      <td mat-cell *matCellDef="let element" class="text-sm uppercase">
                          <!-- <b>{{element?.company?.id}}</b><br> -->
                          {{ element?.company?.name}}
                      </td>
                  </ng-container>

                  <!-- Estado -->
                  <ng-container matColumnDef="statusId">
                      <th mat-header-cell *matHeaderCellDef class="text-sm">Estado</th>
                      <td mat-cell *matCellDef="let element" class="text-sm">
                          <mat-slide-toggle class="custom-slide-toggle primary" [checked]="element.statusId == 1"
                              [(ngModel)]="element.statusId" [color]="'success'"
                              (ngModelChange)="onStatusChange($event, element)">
                          </mat-slide-toggle>
                      </td>
                  </ng-container>
      
                  <!-- Acciones -->
                  <ng-container matColumnDef="action">
                      <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                      <td mat-cell *matCellDef="let element" class="px-6 py-3 text-left">
                          <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                              <mat-icon>more_vert</mat-icon>
                          </button>
                          <mat-menu #actionMenu="matMenu">
                              <button mat-menu-item (click)="openModal(element)">
                                  <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                                  <span>Editar Registro</span>
                              </button>
                              <button mat-menu-item (click)="openDeleteDialog(element)">
                                  <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                                  <span>Eliminar Registro</span>
                              </button>
                          </mat-menu>
                      </td>
                  </ng-container>
      
                  <!-- Header Row -->
                  <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky top-0 z-10 bg-white dark:bg-gray-900"></tr>
      
                  <!-- Fila principal -->
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b h-16"></tr>
                </table>
              </div>
              <div *ngIf="this.dataSource.data.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">Lo sentimos, no hay registros para mostrar.
              </div>
          </div>
  
          <!-- Paginación debería asignar valor a this.pageSize--> 
          <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
              <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
                  [pageSize]="pageSize"  (page)="changePage($event)"></mat-paginator>
          </div>
        </div>
      </div>
    
        <!-- Modal Agregar y Editar -->
        <ng-template #actionModal>
            <h2 mat-dialog-title class="text-lg font-bold mb-1">{{ (this.id == null ? 'Nuevo' : 'Editar')}} Registro</h2>
            <mat-dialog-content class="modal-content">
                <mat-tab-group>
                    <mat-tab label="Datos Generales">
                        <form #modalForm="ngForm">
                            <mat-form-field appearance="fill" class="w-full">
                                <mat-label>Nombre</mat-label>
                                <input matInput [(ngModel)]="currentMemberN.name" name="name" oninput="this.value = this.value.toUpperCase()" required>
                            </mat-form-field>

                            <mat-form-field appearance="fill" class="w-full">
                                <mat-label>Compañía</mat-label>
                                <mat-select [(ngModel)]="currentMemberN.companyId" name="company" (selectionChange)="getAllSalesOfficeList(currentMemberN.companyId)" required>
                                    @for (company of companyFilterList; track company) {
                                    <mat-option [value]="company._id">
                                        {{ company.name }}
                                    </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </form>
                    </mat-tab>

                    <mat-tab label="Correos">
                        <div class="w-full">
                            <table class="w-full">
                                <thead>
                                    <tr>
                                        <th class="align-left w-1/12">#</th>
                                        <th class="align-left w-1/12">Correos</th>
                                        <th class="align-right w-1/12">
                                            <div class="button-container padding-button-container">
                                                <button *ngIf="!openFormAddEmailNotificactionMember"
                                                    mat-icon-button color="primary"
                                                    (click)="openFormAddEmailNotificactionMember = true"
                                                    matTooltip="Nuevo Registro">
                                                    <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                                                    <span></span>
                                                </button>
                                                <button *ngIf="openFormAddEmailNotificactionMember"
                                                    mat-icon-button color="primary"
                                                    (click)="openFormAddEmailNotificactionMember = false;"
                                                    matTooltip="Cerrar">
                                                    <mat-icon svgIcon="heroicons_outline:x-mark"></mat-icon>
                                                </button>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngIf="openFormAddEmailNotificactionMember == true" style=" background: rgba(197, 191, 191, 0.2); border-radius: 12px;">
                                        <td></td>
                                        <td>
                                            <div class="mr-2">
                                                <mat-form-field appearance="fill" class="w-full mt-2 mb-2" appearance="fill" floatLabel="never">
                                                    <!--<mat-label>Correo</mat-label>-->
                                                    <input matInput [(ngModel)]="currentCreateEmailNotificactionMember" oninput="this.value = this.value.toLowerCase()" [ngModelOptions]="{standalone: true}">
                                                </mat-form-field>
                                            </div>
                                        </td>
                                        <td class="align-right">
                                            <div class="button-container padding-button-container">
                                                <button color="primary" mat-icon-button (click)="onAddToListEmailNotificactionMember()">
                                                <mat-icon svgIcon="heroicons_outline:check-circle"></mat-icon>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr *ngFor="let item of emailList; let i = index">
                                        <td valign="center">{{(i+1)}}</td>
                                        <td>
                                            @if (item.isEditMode) {
                                                <div class="mr-2">
                                                    <mat-form-field class="w-full mt-2" appearance="fill" floatLabel="never" [disabled]="!item.isEditMode">
                                                        <!--<mat-label>Correo</mat-label>-->
                                                        <input matInput [(ngModel)]="item.email" oninput="this.value = this.value.toLowerCase()" [ngModelOptions]="{standalone: true}">
                                                    </mat-form-field>
                                                </div>
                                            } @else{
                                                <div class="w-full mt-4 mb-4">
                                                    {{ item.email }}
                                                </div>
                                            }
                                        </td>
                                        <td class="align-right">
                                            <button mat-icon-button color="primary" matTooltip="Editar" (click)="onUpdateEmailNotificactionMember(item)" *ngIf="!item.isEditMode">
                                                <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                                            </button>
                                            <button mat-icon-button color="primary" matTooltip="Guardar" (click)="onSaveEmailNotificactionMember(item)" *ngIf="item.isEditMode">
                                                <mat-icon svgIcon="heroicons_outline:document"></mat-icon>
                                            </button>
                                            <button mat-icon-button color="primary" matTooltip="Borrar" (click)="openDeleteEmailNotificactionMember(item, i, i)">
                                                <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </mat-tab>

                    <mat-tab label="Teléfonos">
                        <div class="w-full">
                            <table class="w-full">
                                <thead>
                                    <tr>
                                        <th class="align-left w-1/12">#</th>
                                        <th class="align-left w-1/12">Telefonos</th>
                                        <th class="align-right w-1/12">
                                            <div class="button-container padding-button-container">
                                                <button *ngIf="!openFormAddPhoneNotificactionMember" mat-icon-button color="primary" (click)="openFormAddPhoneNotificactionMember = true" 
                                                matTooltip="Nuevo Registro">
                                                <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                                                <span></span>
                                                </button>
                                                <button *ngIf="openFormAddPhoneNotificactionMember" mat-icon-button color="primary" (click)="openFormAddPhoneNotificactionMember = false;"
                                                matTooltip="Cerrar">
                                                <mat-icon svgIcon="heroicons_outline:x-mark"></mat-icon>
                                                </button>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngIf="openFormAddPhoneNotificactionMember == true" style=" background: rgba(197, 191, 191, 0.2); border-radius: 12px;">
                                        <td></td>
                                        <td>
                                            <div class="mr-2">
                                                <mat-form-field appearance="fill" class="w-full mt-2 mb-2" appearance="fill" floatLabel="never">
                                                    <!--<mat-label>Correo</mat-label>-->
                                                    <input matInput [(ngModel)]="currentCreatePhoneNotificactionMember" oninput="this.value = this.value.toLowerCase()" [ngModelOptions]="{standalone: true}">
                                                </mat-form-field>
                                            </div>
                                        </td>
                                        <td class="align-right">
                                            <div class="button-container padding-button-container">
                                                <button color="primary" mat-icon-button (click)="onAddToListPhoneNotificactionMember()">
                                                <mat-icon svgIcon="heroicons_outline:check-circle"></mat-icon>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr *ngFor="let item of phoneList; let i = index">
                                        <td valign="center">{{(i+1)}}</td>
                                        <td>
                                            @if (item.isEditMode) {
                                                <div class="mr-2">
                                                    <mat-form-field class="w-full mt-2" appearance="fill" floatLabel="never" [disabled]="!item.isEditMode">
                                                        <!--<mat-label>Correo</mat-label>-->
                                                        <input matInput [(ngModel)]="item.phone" oninput="this.value = this.value.toLowerCase()" [ngModelOptions]="{standalone: true}">
                                                    </mat-form-field>
                                                </div>
                                            } @else{
                                                <div class="w-full mt-4 mb-4">
                                                    {{ item.phone }}
                                                </div>
                                            }
                                        </td>
                                        <td class="align-right">
                                            <button mat-icon-button color="primary" matTooltip="Editar" (click)="onUpdatePhoneNotificactionMember(item)" *ngIf="!item.isEditMode">
                                                <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                                            </button>
                                            <button mat-icon-button color="primary" matTooltip="Guardar" (click)="onSavePhoneNotificactionMember(item)" *ngIf="item.isEditMode">
                                                <mat-icon svgIcon="heroicons_outline:document"></mat-icon>
                                            </button>
                                            <button mat-icon-button color="primary" matTooltip="Borrar" (click)="openDeletePhoneNotificactionMember(item, i, i)">
                                                <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </mat-tab>
                </mat-tab-group>
                
            </mat-dialog-content>
            <mat-dialog-actions class="modal-actions flex justify-end">
                <button mat-button mat-dialog-close class="align-left">Cancelar</button>
                <button mat-raised-button color="primary" (click)="onSubmit()"
                    [disabled]="!modalForm.valid">Guardar</button>
                </mat-dialog-actions>
        </ng-template>
    
        <ng-template #deleteDialog let-data>
            <div class="flex items-start space-x-2 mb-4">
                <div class="flex items-center">
                    <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
                    style="font-size: 32px;"></mat-icon>
                </div>
                <div class="grid">
                    <h2 mat-dialog-title class="text-lg font-bold mb-1">Confirmar eliminación</h2>
                    <mat-dialog-content class="modal-content mt-0">
                        <p>¿Está seguro que desea eliminar el registro?</p>
                    </mat-dialog-content>
                </div>
            </div>
            <mat-dialog-actions class="modal-actions flex justify-end">
                <button mat-button mat-dialog-close class="align-left">Conservar</button>
                <button mat-raised-button color="warn" [mat-dialog-close]="true">Eliminar</button>
            </mat-dialog-actions>
        </ng-template>
    </div>  

    <app-filter (onFilterEvent)="getList()" (onCleanEvent)="onClearEvent()">
		<app-configuration-filters
		[form]="form"
		[company]="true"
        [salesOffice]="true"
        [distributionChain]="true"
		></app-configuration-filters>
	</app-filter>
</mat-sidenav-container>